// src/pages/docs/overview.jsx
import { Typography, Link } from '@mui/material';
import DocsLayout from 'layout/DocsLayout';

const Overview = () => {
  return (
    <DocsLayout>
      <Typography variant="h4" fontWeight="bold" gutterBottom sx={{ mr: 10 }}>
        전적이 시작하기
      </Typography>

      <Typography variant="body1" sx={{ mb: 4 }}>
        명령어 페이지에 오신걸 환영합니다!
      </Typography>

      <Typography variant="body1">
        <Link
          href="https://discord.com/oauth2/authorize?client_id=996765559603613747"
          target="_blank"
          rel="noopener noreferrer"
        >
          여기
        </Link>{' '}
        를 클릭하여 전적이를 서버에 초대할 수 있습니다.
      </Typography>

      <Typography variant="body1">
        전적이는 게임 전적, 급식 정보, 커스텀 명령어, 미니게임 등 다양한 기능을 제공하며,  
        서버를 더욱 재미있고 유용하게 만들어주는 디스코드 봇입니다.<br />
        카테고리를 확인하여 명령어 문서를 통해 기능을 확인해보세요!
      </Typography>
    </DocsLayout>
  );
};

export default Overview;
